import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";

class AssignReferralCodeForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Ref. Code"
              name="referralCode"
              component={DropDownInputField}
              data={this.props.codes}
              valueKey="code"  
              titleKey="code" 
              showBlank={true}
              serverError={this.props.errors.referralCode}
              />
          </FormFieldsTable>
        </div>  
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AssignReferralCodeForm"
})(AssignReferralCodeForm);

export default ReduxForm;